const COUPON_KEY = 'coupon'

let defaultInfo = {
  operateType: 1, // 操作类型：1.创建优惠券 2.查看优惠券 3.编辑优惠券 4.复制优惠券
  couponId: undefined // 当前操作的优惠券ID
}

export function getCouponInfo() {
  return JSON.parse(window.localStorage.getItem(COUPON_KEY))
}

export function setCouponInfo(info = defaultInfo) {
  return window.localStorage.setItem(COUPON_KEY, JSON.stringify(info))
}

export function removeCouponInfo() {
  return window.localStorage.removeItem(COUPON_KEY)
}
